/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiModelsEnumerationTypesDisplayType = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiModelsEnumerationTypesDisplayType = typeof WebApiModelsEnumerationTypesDisplayType[keyof typeof WebApiModelsEnumerationTypesDisplayType];


export function WebApiModelsEnumerationTypesDisplayTypeFromJSON(json: any): WebApiModelsEnumerationTypesDisplayType {
    return WebApiModelsEnumerationTypesDisplayTypeFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesDisplayTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesDisplayType {
    return json as WebApiModelsEnumerationTypesDisplayType;
}

export function WebApiModelsEnumerationTypesDisplayTypeToJSON(value?: WebApiModelsEnumerationTypesDisplayType | null): any {
    return value as any;
}

